export default "__VITE_ASSET__fb067082__"